import React from 'react';

import Footer from '../Footer/Footer';
import OfflineHeader from '../OfflineHeader/OfflineHeader';

function OfflineLayout({ pageProps, children }) {
  const props =
    pageProps && typeof pageProps.page === 'string'
      ? JSON.parse(pageProps.page)
      : pageProps.page;

  return (
    <div itemScope itemType='https://schema.org/WebPage'>
      <OfflineHeader />
      <div className={'page-wrapper'}>{children}</div>
      {props?.navigation && <Footer navigation={props.navigation.top} />}
    </div>
  );
}

export default OfflineLayout;
